import { inject } from 'vue';
import type { InjectionKey } from 'vue';

/**
 * The locale the design system uses for number and date formatting.
 *
 * The design system is framework-agnostic — it never imports the host app's
 * locale config. The host provides its locale ONCE at the root (from
 * `resources/js/config/locale.ts`) under this key; design-system components
 * read it via {@link useDesignSystemLocale}.
 *
 * When nothing is provided (Storybook, component tests, any standalone render)
 * it falls back to the browser/OS locale — the correct degradation. The host
 * wires the real locale in `resources/js/app.js`, alongside the link.
 */
export const DesignSystemLocaleKey: InjectionKey<string> = Symbol('design-system-locale');

/** The host-provided locale, or the browser/OS locale when standalone. */
export function useDesignSystemLocale(): string {
    return inject(DesignSystemLocaleKey, typeof navigator !== 'undefined' ? navigator.language : 'en');
}
